import React from 'react';
import { Check, ChevronDown, ChevronRight, Clock, XIcon, Award } from 'lucide-react';
export function Sidebar({
  isOpen,
  onClose,
  isAssessmentComplete = false,
  isOnResultsScreen = false
}) {
  return <>
      {/* Overlay */}
      {isOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden" onClick={onClose} data-id="element-1104" />}
      {/* Sidebar */}
      
    </>;
}
function SidebarSection({
  title,
  items = [],
  expanded = false
}) {
  return <div className="mb-1" data-id="element-1105">
      <div className="flex items-center justify-between px-6 py-2 cursor-pointer hover:bg-gray-50" data-id="element-1106">
        <div className="flex items-center" data-id="element-1107">
          <div className="w-5 h-5 rounded-full border border-gray-300 flex items-center justify-center mr-3" data-id="element-1108">
            {expanded ? <ChevronDown size={16} data-id="element-1109" /> : <ChevronRight size={16} data-id="element-1110" />}
          </div>
          <span className="font-medium" data-id="element-1111">{title}</span>
        </div>
      </div>
      {expanded && <div className="pl-6" data-id="element-1112">
          {items.map((item, index) => <div key={index} className={`flex items-center py-2 px-6 ${item.active ? 'bg-blue-50' : 'hover:bg-gray-50'}`} data-id="element-1113">
              <div className="w-5 h-5 rounded-full mr-3 flex items-center justify-center" data-id="element-1114">
                {item.completed ? <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-1115">
                    <Check size={14} className="text-green-600" data-id="element-1116" />
                  </div> : item.icon ? <div className="w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-1117">
                    {item.icon}
                  </div> : <div className={`w-5 h-5 rounded-full border ${item.active ? 'border-blue-400' : 'border-gray-300'}`} data-id="element-1118"></div>}
              </div>
              <span className="text-sm flex-1" data-id="element-1119">{item.label}</span>
              {item.time && <div className="text-xs text-gray-500 flex items-center" data-id="element-1120">
                  <Clock size={12} className="mr-1" data-id="element-1121" />
                  {item.time}
                </div>}
            </div>)}
        </div>}
    </div>;
}